var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKebabBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15773_31872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 3.88932C11.6667 4.8098 10.9205 5.55599 10 5.55599C9.07957 5.55599 8.33337 4.8098 8.33337 3.88932C8.33337 2.96885 9.07957 2.22266 10 2.22266C10.9205 2.22266 11.6667 2.96885 11.6667 3.88932Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 10.0004C11.6667 10.9209 10.9205 11.6671 10 11.6671C9.07957 11.6671 8.33337 10.9209 8.33337 10.0004C8.33337 9.07996 9.07957 8.33377 10 8.33377C10.9205 8.33377 11.6667 9.07996 11.6667 10.0004Z",
    fill: "#002CFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 16.1115C11.6667 17.032 10.9205 17.7782 10 17.7782C9.07957 17.7782 8.33337 17.032 8.33337 16.1115C8.33337 15.1911 9.07957 14.4449 10 14.4449C10.9205 14.4449 11.6667 15.1911 11.6667 16.1115Z",
    fill: "#002CFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15773_31872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKebabBlue);
export default __webpack_public_path__ + "static/media/iconKebabBlue.e46e03abae64c117c7017a3f6b62bdaf.svg";
export { ForwardRef as ReactComponent };